export default __webpack_public_path__ + "static/media/homepageBannerImg.7994b678.jpg";